import { render, staticRenderFns } from "./cfp_create.vue?vue&type=template&id=9272ab02&"
import script from "./cfp_create.vue?vue&type=script&lang=js&"
export * from "./cfp_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports